exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".msg-error[data-v-3a7fe777]{background:#f0f0f0;border-radius:4px;font-size:14px;padding:10px;display:inline-block;position:relative;margin-top:5px}.msg-error.admire[data-v-3a7fe777]{color:#fff;background:#0095ff}.msg-error.admire[data-v-3a7fe777]:before{border-color:transparent transparent #0095ff}", ""]);

// exports
